import {Dialog, DialogAlignment, DialogTitle, MessageOverlay, PhoneForm, useStorageItemValue} from "@variocube/cube-ui";
import {style} from "typestyle";
import * as React from "react";
import {useEffect, useState} from "react";
import {Shop} from "./types";
import {logger} from "./logger";
import {useLocalization} from "../i18n";

const log = logger.sub("signup");

interface SignUpDialogProps {
    open: boolean;
    shop: Shop;
    onClose: () => void;
}

export function SignUpDialog({open, shop, onClose}: SignUpDialogProps) {
    const [success, setSuccess] = useState(false);
    const signUpUrl = useStorageItemValue<string>("signUpUrl");

    const {t, language} = useLocalization();

    useEffect(() => {
        setSuccess(false);
    }, [open]);

    async function postSignUp(signUpUrl: string, phone: string, shop: string, locale: string) {
        log.info("Sending signup", {phone, shop, locale});
        try {
            return await window.fetch(signUpUrl, {
                method: "POST",
                headers: {
                    "Content-type": "application/json"
                },
                body: JSON.stringify({
                    input: phone,
                    shop: shop,
                    locale: locale,
                })
            });
        } catch (error) {
            // Network error
            throw t("SignUpFailed");
        }
    }

    async function handleSubmit(phone: string) {
        if (!signUpUrl) {
            throw new Error("`signUpUrl` not defined.");
        }
        const response = await postSignUp(signUpUrl, phone, shop.id, language);
        if (response.status == 400) {
            throw t("SignUpInvalidNumber");
        }
        else if (!response.ok) {
            throw t("SignUpFailed");
        }
        setSuccess(true);
    }

    return (
        <Dialog open={open} align={DialogAlignment.Center} onBackdropClick={onClose}>
            <div className={style({width: "45em"})}>
                <DialogTitle>
                    {t("SignUpNow")}
                </DialogTitle>
                {open && (
                    <PhoneForm onSubmit={handleSubmit} onCancel={onClose} strings={t}/>
                )}
            </div>
            <MessageOverlay
                open={success}
                onClose={onClose}
                autoClose={20}
                success
                message={t("SignUpSucceeded")}
                strings={t}
            />
        </Dialog>
    );
}
